import { Stack, Toolbar, Typography } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { ConfigService } from '../../services';

const Footer = () => {
    return (
        <AppBar color="primary" position="static">
            <Toolbar>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} style={{ width: '100%' }}>
                    <Stack direction={'row'} alignContent={'center'} justifyContent={'center'}>
                        <Typography>Copyright © {new Date().getFullYear()} by ABS. All rights reserved.</Typography>
                    </Stack>
                    <Typography>v{ConfigService.appConfig.lastUpdate}</Typography>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
